import {BaseError} from 'make-error'

export class BadResponse extends BaseError {
  constructor(status) {
    super(`Bad Response: ${status}.`)
  }
}
export class FitCalculateError extends BaseError {}
export class FitCannotChangeMeasurementsError extends BaseError {
  constructor(date) {
    super('Cannot change measurements. User has a checked out event within 30 days.')
    this.date = date
  }
}
export class RedirectError extends BaseError {
  constructor(redirect) {
    super()
    this.redirect = redirect
  }
}
export class FitStepGatedError extends RedirectError {}
export class FitStepDoesNotExistError extends RedirectError {}

export class InvalidSizeCombinationError extends BaseError {}
export class ValidationError extends BaseError {}

export class LoginError extends BaseError {
  constructor(message, {email, password}) {
    super(message)
    this.email = email
    this.password = password
  }
}

export class UserIsNotAuthenticatedError extends RedirectError {}

export class ApiError extends BaseError {
  constructor(type) {
    super()
    this.type = type
  }
}

/**
 * Handles Django field-level validation error objects for passing through
 * Redux actions and storing in state.
 */
export class FieldValidationErrors extends BaseError {
  constructor(errors) {
    super()
    this.errors = errors
  }
}

export class LocationsSearchError extends BaseError {
  constructor({isBadRequest}) {
    super()
    this.isBadRequest = isBadRequest
    this.message = 'Unable to fetch location by zip and radius'
  }
}
